module.exports = __webpack_public_path__ + "static/media/zombies.c8c34e6a.jpg";